function formatCurrency(number: number | string) {
  if (!number) {
    return `$0.00`;
  }

  const value = Number(number);

  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const currencyUtils = {
  formatCurrency,
};

export default currencyUtils;
